import { render, staticRenderFns } from "./GuideBookPaperPlaceOfSales.vue?vue&type=template&id=2a116262"
import script from "./GuideBookPaperPlaceOfSales.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperPlaceOfSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports